import { Button, Card, Col, Flex, Row, Space } from "antd";
import DashboardLayout from "../../../layouts/DashboardLayout";
import { useNavigate, useParams } from "react-router";
import ArrowLeftIcon from "../../../assets/icons/ArrowLeftIcon";
import CustomTitle from "../../../components/CustomTitle";
import StateCard from "../../../components/StateCard";
import UsersIcon from "../../../assets/icons/UsersIcon";
import RoundUserIcon from "../../../assets/icons/RoundUserIcon";
import CorrectIcon from "../../../assets/icons/CorrectIcon";

export default function LearnerDetails() {
  const navigate = useNavigate();
  const { id } = useParams();
  return (
    <DashboardLayout title="Quiz Details">
      <Flex justify="start" align="center" className="mb-4" gap={16}>
        <Button
          type="default"
          size="middle"
          className="btn-bordered-primary border
               border-zinc-200 hover:!border-zinc-200 focus:!border-zinc-200 active:!border-zinc-200"
          onClick={() => navigate(`/admin/quiz/${id}`)}
        >
          <ArrowLeftIcon /> Back
        </Button>
        <CustomTitle
          title="Tariq Islam's Quiz Results"
          description="JavaScript Fundamentals Quiz - Complete Web Development Bootcamp"
        />
      </Flex>

      <Row gutter={[16, 16]} className="mb-5">
        <Col span={6}>
          <StateCard
            icon={<UsersIcon className="text-[#2497EB] text-2xl" />}
            title="Total Attempts"
            count={`540`}
            iconClass="bg-sky-100"
          />
        </Col>
        <Col span={6}>
          <StateCard
            icon={<RoundUserIcon className="text-[#4C56BB] text-2xl" />}
            title="Average Score"
            count={`78%`}
            iconClass="bg-indigo-100"
          />
        </Col>
        <Col span={6}>
          <StateCard
            icon={<RoundUserIcon className="text-[#4C56BB] text-2xl" />}
            title="Pass Rate"
            count={`78%`}
            iconClass="bg-indigo-100"
          />
        </Col>
        <Col span={6}>
          <StateCard
            icon={<CorrectIcon className="text-[#0A9952] text-2xl" />}
            title="Pass Score"
            count={`70%`}
            iconClass="bg-green-100"
          />
        </Col>
      </Row>

      <Card
        className="rounded-md shadow-sm w-full"
        bodyStyle={{ padding: "18px" }}
      >
        <div className="justify-start text-zinc-700 text-lg font-medium mb-3">
          Learner Information
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
          {learnerInfo.map((item, index) => (
            <div key={index}>
              <Space size={16}>
                <div className="p-2 bg-sky-100 rounded-xl inline-flex justify-center items-center gap-2.5">
                  <UsersIcon className="text-[#2497EB] text-2xl" />
                </div>

                <div>
                  <div className="justify-start text-slate-500 text-sm font-normal">
                    {item.label}
                  </div>
                  <div className="justify-start text-zinc-700 text-base font-medium">
                    {item.value}
                  </div>
                </div>
              </Space>
            </div>
          ))}
        </div>
      </Card>
    </DashboardLayout>
  );
}

const learnerInfo = [
  { label: "Learner Name", value: "Tariq Islam" },
  { label: "Email Address", value: "tariqislam@email.com" },
  { label: "Course", value: "Mathematics" },
  { label: "Score", value: "85%" },
];
